/** Split out of `registry.js` (PR4): a content block (`PlansBlock`) needs `scrollToSection` for
 * its CTAs, and `registry.js` needs to import that same block into `PSEUDO_REGISTRY` — importing
 * this straight from `registry.js` would make the two modules import each other. Neither
 * function here touches `SECTION_REGISTRY`/`sectionsFor`, so they belong in their own leaf
 * module regardless; `registry.js` re-exports both so existing callers are unaffected. */

/** The DOM id a rendered section's wrapper carries, so a primary action / quick-action button can
 * scroll to it now that sections are always-stacked rather than behind a tab. */
export function sectionElementId(key) {
  return `storefront-section-${key}`;
}

export function scrollToSection(key) {
  document.getElementById(sectionElementId(key))?.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** Whether the section is actually on the page — a CTA that points at an absent section must fall
 * back to a real action (call), never a silent no-op scroll. */
export function hasSection(key) {
  return Boolean(document.getElementById(sectionElementId(key)));
}
